export const sliderItems = [
  {
    id: 1,
    img: "./images/slide1.png",
    title: "SUMMER SALE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "f5fafd",
  },
  {
    id: 2,
    img: "./images/slide2.png",
    title: "Indian Traditional",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fcf1ed",
  },
  {
    id: 3,
    img: "./images/slide3.png",
    title: "Formal Men",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fbf0f4",
  },
];

export const categories = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/965324/pexels-photo-965324.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "SUNGLASS LOVE",
    cat: "sunglass",
  },
  {
    id: 2,
    img: "https://images.unsplash.com/photo-1536766820879-059fec98ec0a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
    title: "PARTY SHIRT!",
    cat: "jeans",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/2737004/pexels-photo-2737004.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "JEANS JACKETS",
    cat: "jackets",
  },
];
export const popularProducts = [
  {
    id: 1,
    img: "https://pngimg.com/uploads/hoodie/hoodie_PNG12.png",
  },
  {
    id: 2,
    img: "https://pngimg.com/uploads/jeans/jeans_PNG5764.png",
  },
  {
    id: 3,
    img: "https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
  },
  {
    id: 4,
    img: "https://www.burdastyle.com/pub/media/catalog/product/cache/7bd3727382ce0a860b68816435d76e26/107/BUS-PAT-BURTE-1320516/1170x1470_BS_2016_05_132_front.png",
  },
  {
    id: 5,
    img: "https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
  },
  {
    id: 6,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
  },
  {
    id: 7,
    img: "https://pngimg.com/uploads/dress/dress_PNG163.png",
  },
  {
    id: 8,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
  },

  {
    id: 9,
    img: "https://pngimg.com/uploads/dress_shirt/dress_shirt_PNG8079.png",
  },
  {
    id: 10,
    img: "https://pngimg.com/uploads/dress/dress_PNG189.png",
  },
  {
    id: 11,
    img: "https://pngimg.com/uploads/women_shoes/women_shoes_PNG7474.png",
  },
  {
    id: 12,
    img: "https://pngimg.com/uploads/leggings/leggings_PNG48.png",
  },
];
